import React from 'react';
import { useSelector } from 'react-redux';
import clsx from 'clsx';
import { selectBusyPercentage, selectIsBusy } from '../../features/feedback/feedbackSlice';

/**
 * A thin line across the top of the screen while any request the user is
 * waiting on is out, above dialogs and toasts alike.
 *
 * It answers the question the trigger cannot when it is gone — a menu item, a
 * page change — and the one a fast request leaves open: did anything happen?
 * It slides while the request cannot say how far along it is, fills while a
 * file goes up, and finishes as a full line that fades, so even a request of a
 * few milliseconds has a visible start and end. Always mounted: the fade is a
 * CSS transition between its two states.
 */
export const ActivityBar = () => {
  const busy = useSelector(selectIsBusy);
  const percentage = useSelector(selectBusyPercentage);
  const determinate = busy && percentage !== null;

  return (
    <div
      aria-hidden="true"
      data-testid="activity-bar"
      data-active={busy}
      className={clsx(
        'fixed inset-x-0 top-0 z-[10060] h-[3px] overflow-hidden pointer-events-none transition-opacity',
        busy ? 'opacity-100 duration-150' : 'opacity-0 duration-700'
      )}
    >
      <div
        data-testid="activity-bar-fill"
        className={clsx(
          'h-full bg-ninja-green',
          !busy && 'w-full',
          busy && !determinate && 'w-1/3 animate-activity-slide',
          determinate && 'transition-[width] duration-300'
        )}
        style={determinate ? { width: `${percentage}%` } : undefined}
      />
    </div>
  );
};
